import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const paginationStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  font-size: ${theme.fontSize.md}px;
  color: ${theme.color.textMuted};
`;

export const pageButtonStyle = css`
  padding: ${theme.space.xs / 2}px ${theme.space.sm}px;
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.sm}px;
  background: ${theme.color.surface};
  color: ${theme.color.text};
  cursor: pointer;
  line-height: 1.2;
`;
